/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Tab } from 'react-bootstrap';
import _ from 'lodash';
import './loaddetails.css';
import '../Newload/newLoad.css';
import { StoreContext } from '../Store';
import { useSecurity } from '../Security/security';
import {
  getReportDetails,
  getNewLoad,
  getEidr,
  getOrderForms,
  getNewLoadDropdown,
  getPortProcessDropdown,
  getPreferenceClaimDropdown,
} from '../apiCalls';
import { generateAdjustmentsObject } from '../Adjustments/utils';
import LoadDetails from './LoadDetails';
import LoadItems from './LoadItems';
import LoadStatus from './LoadStatus';
import OrderForm from '../Newload/OrderForm';
import QAChecklistTab from '../Newload/QAChecklistTab/QAChecklistTab';
import QAStoreProvider from '../Newload/QAChecklistTab/QAStore';
import { populateIpaffsModalData } from '../ipaffs/utils';
import { fetchExchangeRate, normalizePreferenceClaimOptions } from '../Newload/QAChecklistTab/utils';
import { isGBImport, isGBexport } from '../../utils/loads';
import { getExciseOptions } from '../../api/excise';

const Loads = (props) => {
  const store = useContext(StoreContext);
  const [currentTab, setCurrentTab] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [headerData, setHeaderData] = useState({});
  const [adjustments, setAdjustments] = useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const { validateRole } = useSecurity();
  const IsQAUser = validateRole({ department: 'QA' });
  const { id } = useParams();

  const transformItemsData = (data) => {
    if (!data) return [];
    const returnData = data.map((item) => ({
      commoditycode: item.commodityCode,
      origin: item.origin,
      id: item.id,
      description: item.description,
      packageCount: item.noOfPkgs,
      packageType: item.typeOfPkgs,
      grossMass: item.grossKG,
      netMass: item.netKG,
      itemValue: item.loadValue,
      healthCert: item.healthCert,
      organic: item.organic,
      preferential: ['YES', '1', 1].includes(item.preferential) ? 'YES' : 'NO',
      dutyLiability: item?.dutyLiability,
      vatLiability: item?.vatLiability,
      VAT: item?.VAT,
      invoiceNumber: item.InvoiceNumber,
      customsValue: item?.customsValue ? item?.customsValue : 0,
      exciseProductType: item?.exciseProductType,
      exciseTaxCode: item?.exciseTaxCode,
      neeNoridconsignor: item?.Consignorid,
    }));
    return returnData;
  };

  const updateAdjustmentData = (returnData, currencyList) => {
    const adjustmentData = generateAdjustmentsObject(returnData, currencyList);
    store.adjustments[1](adjustmentData);
  };

  useEffect(() => {
    async function fetchData() {
      const currencyList = await getNewLoad('currency');
      store.currencyOptions[1](currencyList);

      getNewLoad('vat').then((data) => {
        store.VatOptions[1](data);
      });
      getNewLoad('pref').then((data) => {
        store.PreferentialOptions[1](data);
      });

      getNewLoad('fcl').then((data) => {
        store.loadTypeOptions[1](data);
      });
      getNewLoad('shipStatus').then((data) => {
        store.shippingStatusOptions[1](data);
      });
      getNewLoad('movement').then((data) => {
        store.movementOptions[1](data);
      });
      getNewLoad('currency').then((data) => {
        store.currencyOptions[1](data);
      });
      getNewLoad('incoterm').then((data) => {
        store.incotermsOptions[1](data);
      });
      getExciseOptions().then((data) => {
        store.exciseOptions[1](data);
      });

      const data = await getReportDetails('details', id);
      const returnData = await getEidr(id);
      updateAdjustmentData(returnData, currencyList);
      const orderForms = await getOrderForms(id);
      const orderforms = orderForms?.[0]?.orderforms && JSON.parse(orderForms?.[0]?.orderforms);
      setSelectedForms(orderforms ?? []);

      setIsReadOnly(returnData?.Headers?.[0]?.readonly);
      store.clientIDname[1](data?.[0]?.companyName);

      getNewLoadDropdown('despatch', returnData.Headers[0].movementTypeId).then((data) => {
        store.despatchCountryOptions[1](data);
      });
      getNewLoadDropdown('exit', returnData.Headers[0].movementTypeId).then((data) => {
        store.exitPortOptions[1](data);
      });
      getNewLoadDropdown('destination', returnData.Headers[0].movementTypeId).then((data) => {
        store.entryCountryOptions[1](data);
      });
      getNewLoadDropdown('entry', returnData.Headers[0].movementTypeId).then((data) => {
        store.entryPortOptions[1](data);
      });
      getPortProcessDropdown('portprocessdropdown', returnData.Headers[0].movementTypeId).then((data) => {
        store.portsModalOptions[1](data);
      });
      getPreferenceClaimDropdown().then((data) => {
        store.QAPreferenceClaimOptions[1](normalizePreferenceClaimOptions(data));
      });

      store.loadId[1](returnData.Headers[0].id);
      store.clientID[1](returnData.Headers[0].clientID);
      store.clientIDerror[1](returnData.Headers[0].clientIDerror);
      store.declarant[1](returnData.Headers[0].Declarant);
      store.directionSelected[1](returnData.Headers[0].movementTypeId);
      store.selectFcl[1](returnData.Headers[0].fclId);
      store.despatch[1](returnData.Headers[0].CountryofDesptachid);
      store.destination[1](returnData.Headers[0].CountryofDestinationid);
      store.exit[1](returnData.Headers[0].ExitPort1id);
      store.entry[1](returnData.Headers[0].EntryPort1id);
      store.exit2[1](returnData.Headers[0].ExitPort2id);
      store.entry2[1](returnData.Headers[0].EntryPort2id);
      store.consignor[1](returnData.Headers[0].Consignorid);
      store.consignee[1](returnData.Headers[0].Consigneeid);
      store.consignorRPA[1](returnData.Headers[0].Consignorid);
      store.consigneeRPA[1](returnData.Headers[0].Consigneeid);
      store.shipStatus[1](returnData.Headers[0].shipStatus);
      store.truck[1](returnData.Headers[0].trucktext);
      store.trailer[1](returnData.Headers[0].trailerSeal);
      store.date[1](returnData.Headers[0].loadingDate && returnData.Headers[0].loadingDate.split('T')[0]);
      store.jobRef[1](returnData.Headers[0].jobRef);
      store.jiraTicket[1](returnData.Headers[0].jiraTicket);
      store.portalRef[1](returnData.Headers[0].portalRef);
      store.loadTypeDescription[1](returnData.Headers[0].loadTypeDescription);
      store.invoicenumber[1](returnData.Headers[0].InvoiceNumber);
      store.invoicecurr[1](returnData.Headers[0].InvoiceCurrencyid);
      store.selectincoterm[1](returnData.Headers[0].Incotermid);
      store.incotermLocation[1](returnData.Headers[0].incotermLocation);
      store.exitPortDefault[1](returnData.Headers[0].exitportdefault);
      store.entryPortDefault[1](returnData.Headers[0].entryportdefault);
      store.GBimport[1](isGBImport(returnData.Headers[0].movementTypeId));
      store.GBexport[1](isGBexport(returnData.Headers[0].movementTypeId));
      store.controlledGoods[1](returnData.Headers[0].controlledGoods);
      store.trailerSeal[1](returnData.Headers[0].trailerSeal);
      store.officeOfDest[1](returnData.Headers[0].officeOfDest);
      store.trailer[1](returnData.Headers[0].trailer);
      store.container[1](returnData.Headers[0].imo);
      store.container[1](returnData.Headers[0].container);
      returnData.Headers[0]?.parentName &&
        store.newLoadParent[1]({
          parentId: returnData.Headers[0]?.parentId,
          parentName: returnData.Headers[0]?.parentName,
          parentEori: returnData.Headers[0]?.parentEori,
        });
      if (returnData.Headers[0].entryporthybrid) {
        store.importMixedPortsModal[1](1);
      }
      if (returnData.Headers[0].exitporthybrid) {
        store.exitMixedPortsModal[1](1);
      }
      store.portsModal[1](returnData.Headers[0].portModal);
      store.validatedRowsReadyToSubmit[1](transformItemsData(returnData?.Items));
      store.GBimport[1](isGBImport(returnData.Headers[0].movementTypeId));
      store.GBexport[1](isGBexport(returnData.Headers[0].movementTypeId));
      store.representative[1](returnData?.Headers?.[0].representative);
      store.ipaffsCategories[1](populateIpaffsModalData(returnData?.Items));
      store.certificateCount[1](returnData?.Headers[0]?.certificateCount ?? 0);
      store.multipleConsignors[1](returnData.Headers[0].multipleConsignor);
      store.multipleInvoices[1](returnData.Headers[0].multipleInvoice);
      store.loadStatus[1](returnData?.Headers[0]?.status);
      const apiChedQty = returnData?.Headers?.[0]?.qTracesChed;
      if (apiChedQty !== undefined && apiChedQty !== null) {
        store.qTracesChed?.[1]?.(Number(apiChedQty) || 0);
      }
      setHeaderData(data[0]);
      setCurrentTab(IsQAUser ? 4 : 2);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (store.currencyOptions[0]?.length > 0 && !_.isEmpty(headerData)) {
      setAdjustments(generateAdjustmentsObject(headerData, store.currencyOptions[0], true));
    }
  }, [store.currencyOptions[0], headerData]);

  useEffect(() => {
    fetchExchangeRate(store.currencyOptions[0], store.invoicecurr[0], store.date[0], store.exchangeRate[1]);
  }, [store.currencyOptions[0], store.invoicecurr[0], store.date[0]]);

  const renderContainer = () => {
    return (
      <Container fluid className="semi-fluid-container">
        <Tab.Container activeKey={currentTab}>
          <div className="semi-fluid-container mb-4">
            <div className="tab-header loadlist">
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 0 ? 'done' : currentTab === 0 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(0)}
              >
                <NumberedCircle i={0} />
                <span>Header</span>
              </button>

              <div className={'horizontal-line flex-grow-1 rounded-pill breadcrumb-line'} />
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 1 ? 'done' : currentTab === 1 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(1)}
              >
                <NumberedCircle i={1} />
                <span>Items</span>
              </button>

              <div className={'horizontal-line flex-grow-1 rounded-pill breadcrumb-line'} />
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 2 ? 'done' : currentTab === 2 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(2)}
              >
                <NumberedCircle i={2} />
                <span>Status</span>
              </button>
            </div>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey={0}>
              <div className="semi-fluid-container">
                <LoadDetails adjustments={adjustments} headerData={headerData} nextPage={() => setCurrentTab(1)} />
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey={1}>
              <div className="semi-fluid-container">
                <LoadItems
                  headerData={headerData}
                  invoicenumber={id}
                  portalRef={headerData?.portalRef}
                  nextPage={() => setCurrentTab(2)}
                  prevPage={() => {
                    setCurrentTab((prev) => prev - 1);
                  }}
                />
              </div>
              <div className="w-100 d-flex justify-content-end mt-3"></div>
            </Tab.Pane>

            <Tab.Pane eventKey={2}>
              <div className="semi-fluid-container">
                <LoadStatus
                  isReadOnly={isReadOnly}
                  headerData={headerData}
                  invoicenumber={id}
                  portalRef={headerData?.portalRef}
                  prevPage={() => {
                    setCurrentTab((prev) => prev - 1);
                  }}
                />
              </div>
              <div className="w-100 d-flex justify-content-end mt-3"></div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    );
  };

  const renderQAContainer = () => {
    return (
      <Container fluid className="semi-fluid-container">
        <Tab.Container activeKey={currentTab}>
          <div className="semi-fluid-container mb-4">
            <div className="tab-header loadlist">
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 0 ? 'done' : currentTab === 0 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(0)}
              >
                <NumberedCircle i={0} />
                <span>Header</span>
              </button>

              <div className={'horizontal-line flex-grow-1 rounded-pill breadcrumb-line'} />
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 1 ? 'done' : currentTab === 1 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(1)}
              >
                <NumberedCircle i={1} />
                <span>Items</span>
              </button>

              <div className={'horizontal-line flex-grow-1 rounded-pill breadcrumb-line'} />
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 2 ? 'done' : currentTab === 2 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(2)}
              >
                <NumberedCircle i={2} />
                <span>Order Form</span>
              </button>

              <div className={'horizontal-line flex-grow-1 rounded-pill breadcrumb-line'} />
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 3 ? 'done' : currentTab === 3 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(3)}
              >
                <NumberedCircle i={3} />
                <span>QA</span>
              </button>

              <div className={'horizontal-line flex-grow-1 rounded-pill breadcrumb-line'} />
              <button
                className={`tab-control text-eoriblue ${
                  currentTab > 4 ? 'done' : currentTab === 4 ? 'active' : 'neutral'
                }`}
                onClick={() => setCurrentTab(4)}
              >
                <NumberedCircle i={4} />
                <span>Status</span>
              </button>
            </div>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey={0}>
              <div className="semi-fluid-container">
                <LoadDetails adjustments={adjustments} headerData={headerData} nextPage={() => setCurrentTab(1)} />
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey={1}>
              <div className="semi-fluid-container">
                <LoadItems
                  headerData={headerData}
                  invoicenumber={id}
                  portalRef={headerData?.portalRef}
                  nextPage={() => setCurrentTab(2)}
                  prevPage={() => {
                    setCurrentTab((prev) => prev - 1);
                  }}
                />
              </div>
              <div className="w-100 d-flex justify-content-end mt-3"></div>
            </Tab.Pane>

            <Tab.Pane eventKey={2}>
              <div className="semi-fluid-container">
                <OrderForm
                  visible={currentTab === 2}
                  firstPage={null}
                  nextPage={null}
                  submit={() => setCurrentTab(3)}
                  showQATab={true}
                  createLoadToPost={null}
                  selectedForms={selectedForms}
                  setSelectedForms={setSelectedForms}
                  readOnly={true}
                />
              </div>
              <div className="w-100 d-flex justify-content-end mt-3"></div>
            </Tab.Pane>

            <Tab.Pane eventKey={3}>
              <div className="semi-fluid-container">
                <QAStoreProvider>
                  <QAChecklistTab
                    visible={currentTab === 3}
                    submitLoadAsDraft={null}
                    submitLoad={null}
                    readOnly={true}
                    loadId={id}
                    selectedForms={selectedForms}
                  />
                </QAStoreProvider>
              </div>
              <div className="w-100 d-flex justify-content-end mt-3"></div>
            </Tab.Pane>

            <Tab.Pane eventKey={4}>
              <div className="semi-fluid-container">
                <LoadStatus
                  isReadOnly={isReadOnly}
                  headerData={headerData}
                  invoicenumber={id}
                  portalRef={headerData?.portalRef}
                  prevPage={() => {
                    setCurrentTab((prev) => prev - 1);
                  }}
                />
              </div>
              <div className="w-100 d-flex justify-content-end mt-3"></div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    );
  };

  return (
    <Container fluid id="breadcrumb-tabber" className="pt-4 mt-3">
      <div className="floating-back-button d-none d-lg-block">
        {currentTab > 0 && (
          <button
            className="blue-button-newload"
            style={{
              borderTopLeftRadius: '0px',
              borderBottomLeftRadius: '0px',
              borderTopRightRadius: '0.75rem',
              borderBottomRightRadius: '0.75rem',
              padding: '0.25rem',
              width: '2.5rem',
            }}
            onClick={() => {
              setCurrentTab((prev) => prev - 1);
            }}
          >
            <LeftChevron />
          </button>
        )}
      </div>
      {IsQAUser ? renderQAContainer() : renderContainer()}
    </Container>
  );
};

const LeftChevron = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="icon-lg" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

const NumberedCircle = ({ i, bg, fg }) => <span className={`icon-md ${bg} ${fg} rounded-circle`}>{i + 1}</span>;

export default Loads;
